module.exports = __webpack_public_path__ + "img/c-en-15.2b67c8bf.png";